export default "__VITE_ASSET__B3P_ZDpF__"